import { Div } from "@tblabs/truffle";


export class FatalError extends Div
{
    constructor(message: string)
    {
        super();
        this.Style(`
            margin:32px;
            padding:32px;
            background-color: #f00;
            color: #fff;
            padding: 10px;
            border-radius: 5px;
        `);

        this.Text(message);
    }
}
